import * as React from "react";
import { SVGProps } from "react";

const Odem = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 199" {...props}>
    <path
      fill="#1eb3de"
      d="M191.65 120 157 154.63v-2.83a5.34 5.34 0 0 0-1.6-3.89l-4.11-4 32.09-32.09a16.73 16.73 0 0 0 0-23.62L111.7 16.5a16.72 16.72 0 0 0-23.62 0L16.45 88.17a16.73 16.73 0 0 0 0 23.62l71.69 71.69a16.7 16.7 0 0 0 23.61 0l26.72-26.72 1.38 1-.16 14.66-19.46 19.2a28.54 28.54 0 0 1-40.23 0L8.29 120a28.33 28.33 0 0 1 0-40L79.94 8.29a28.3 28.3 0 0 1 40 0L191.65 80a28.34 28.34 0 0 1 0 40Z"
    />
    <path
      fill="#1eb3de"
      d="m155.47 147.91-4.11-4L113 106.29a14.52 14.52 0 1 0-7.84 7.24l20.63 20.24 18.6 17.07 1.8 1.66a2.54 2.54 0 0 1 .83 2l-.02 10.41v21.58l-.3 4.37a5.45 5.45 0 0 0 5 5.8h.09a5.68 5.68 0 0 0 5.33-5.63v-39.11a5.55 5.55 0 0 0-1.65-4.01Z"
    />
    <path
      fill="#1eb3de"
      d="M99.56 108a8 8 0 1 1 8.41-8 8.18 8.18 0 0 1-.09 1.23A8 8 0 0 1 100 108Z"
    />
  </svg>
);

export default Odem;
